import colors from 'style-utils/colors';
import typographicScale from 'style-utils/typographic-scale';

const selectTheme = {
  select: {
    typography: {
      color: colors.inputColor,
      fontSize: typographicScale.input,
      fontWeight: '500',
      desktop: {
        fontSize: typographicScale.input,
      },
    },
    rootWrapper: {
      display: 'inline-flex',
    },
    root: {
      flex: '0 1 auto',
      width: 'unset',
      height: 'unset',
    },
    listboxRoot: {
      minWidth: '50px',
      maxWidth: '180px',
      width: 'auto',
      height: '44px',
      margin: '0',
      desktop: {
        minWidth: '50px',
        maxWidth: '180px',
        width: 'auto',
        height: '44px',
        margin: '0',
      },
    },
    button: {
      iconColor: 'currentColor',
      justify: 'space-between',
      borderRadius: '4px',
      border: '2px solid #D1D2D8',
      boxShadow: 'none',
      padding: '0',
      contentPadding: '0 0 0 13px',
      desktop: {
        padding: '0 10px',
        contentPadding: '0 0 0 13px',
      },
    },
    buttonWrapper: {
      right: '13px',
    },
    list: {
      marginTop: '42px',
      borderRadius: '0 0 8px 8px',
      background: colors.bgSecondary,
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
      border: 'none',
      borderTop: 'none',
      // It is 'rootHeight' + 40px.
      padding: '0',
      desktop: {
        padding: '0',
      },
      expanded: {
        // Controls the amount of visible options when it is expanded.
        height: 'auto',
        maxHeight: '280px',
      },
    },
    listItem: {
      padding: '0 46px 0 13px',
      height: '32px',
      margin: '0',
      selected: {
        background: colors.white,
      },
      hover: {
        boxShadow: '',
        background: '',
      },
    },
    icon: {
      color: colors.midGrey,
      backgroundColor: colors.white,
    },
  },
};

export default selectTheme;
